import React from "react";
import { BigLogo } from "./icons";
import Link from "../utils/link";
import { getMenu } from "../utils/menu";

function Footer({ data }) {
  const menuBook = getMenu(data, "footerBook");
  const menuExplore = getMenu(data, "footerExplore");

  return (
    <footer className="flex flex-col justify-center items-center py-28 w-full bg-sky max-md:py-[44px]">
      <div className="inner">
        <Link className="footer__logo block md:mb-0 mb-[80px]" to="/">
          <BigLogo />
        </Link>

        <div className="flex gap-5 justify-between mt-28 w-full max-md:items-end">
          <div className="flex self-start text-sm font-light leading-loose text-orange-100 uppercase tracking-[2px] max-md:max-w-full">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/1ac2c893557246f8ad2241f924b6a397/b2550f997b5815ebf58db4364b2e9eb86f7531e0?placeholderIfAbsent=true"
              alt="Decorative element"
              className="object-contain z-10 shrink-0 self-end mt-36 mr-0 w-10 aspect-square max-md:mt-10 hidden md:block"
            />
            <nav className="flex flex-wrap flex-auto gap-4 md:gap-10 items-start max-md:max-w-full">
              <div className="min-h-11 md:w-[157px]">
                {menuBook.map((item) => (
                  <Link key={item.id} to={item.path} className="flex-1 block">{item.label}</Link>
                ))}
              </div>
              <div className="whitespace-nowrap md:min-h-[180px] md:min-w-60 md:w-[244px]">
                {menuExplore.map((item, index) => (
                  <Link
                    key={item.id}
                    to={item.path}
                    className={`flex-1 block${index > 0 ? " mt-4" : ""}`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </nav>
          </div>

          <div className="flex flex-col md:min-h-[215px]">
            <div className="flex-1 text-sm font-light leading-8 text-right text-orange-100 uppercase tracking-[2px]">
              <a href="tel:++61353271200" className="block underline">phone</a>
              <a href="mailto:reception@mercureballarat.com.au" className="block underline">Email</a>
              <br />
              <address className="not-italic max-md:mt-[40px]">
                613 main road
                <br />
                Ballarat vic 3350
              </address>
              <a href="https://www.google.com/maps/place/Mercure+Ballarat+-+Hotel+%26+Convention+Centre/@-37.5794592,143.8685492,15z/data=!4m9!3m8!1s0x6ad1451e888ea72b:0xa0ae3290fd68ebc8!5m2!4m1!1i2!8m2!3d-37.5794592!4d143.8685492!16s%2Fg%2F1tnl1jgp" className="block underline">map</a>
            </div>
            <div className="flex gap-2 items-center self-end mt-5 max-md:mt-7">
              <a href="https://www.instagram.com/mercure.ballarat" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/1ac2c893557246f8ad2241f924b6a397/b8bae6ae62c7cd8205832d81d04192490aae227b?placeholderIfAbsent=true"
                  alt="Facebook"
                  className="object-contain shrink-0 self-stretch my-auto aspect-square fill-orange-100 w-[25px]"
                />
              </a>
              <a href="https://www.facebook.com/mercureballaratofficial" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/1ac2c893557246f8ad2241f924b6a397/1c16dab1bf3945c163a96457b40d1f59f687fe5c?placeholderIfAbsent=true"
                  alt="Instagram"
                  className="object-contain shrink-0 self-stretch my-auto aspect-square w-[25px]"
                />
              </a>
              <a href="https://www.tripadvisor.com/Hotel_Review-g255346-d258253-Reviews-Mercure_Ballarat_Hotel_and_Convention_Centre-Ballarat_Victoria.html" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/1ac2c893557246f8ad2241f924b6a397/028302adcc2caa44c5c6a063f4b6c3bc78f106ed?placeholderIfAbsent=true"
                  alt="Twitter"
                  className="object-contain shrink-0 self-stretch my-auto aspect-square w-[25px]"
                />
              </a>
              <a href="https://www.google.com/maps/place/Mercure+Ballarat+-+Hotel+%26+Convention+Centre/@-37.5794592,143.8685492,15z/data=!4m9!3m8!1s0x6ad1451e888ea72b:0xa0ae3290fd68ebc8!5m2!4m1!1i2!8m2!3d-37.5794592!4d143.8685492!16s%2Fg%2F1tnl1jgp" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/1ac2c893557246f8ad2241f924b6a397/b4196f80649430f9ae367ce521017a299bd8e61e?placeholderIfAbsent=true"
                  alt="LinkedIn"
                  className="object-contain shrink-0 self-stretch my-auto aspect-square fill-orange-100 w-[25px]"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col mt-11 w-full max-md:mt-[60px] max-md:max-w-full border-t border-cream">
          <div className="flex md:flex-wrap gap-10 justify-between items-center mt-7 w-full max-md:max-w-full">
            <p className="self-stretch md:my-auto text-subheading-s1 font-[300] tracking-[0.2px] text-cream">
              © 2025 Mercure Ballarat - Hotel & Function Centre Pty Ltd. <br />
              Design by <a href="https://atollon.com.au/?utm_source=mercure&utm_medium=website&utm_campaign=referrer&utm_term=hospitality" target="_blank" rel="noopener noreferrer">Atollon</a>
            </p>
            <div className="flex flex-col-reverse md:flex-row gap-4 md:gap-[85px] items-center self-stretch my-auto md:min-w-60 max-md:max-w-full">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/1ac2c893557246f8ad2241f924b6a397/495ef2c7f51997f8fecc0ea81b09f9a2d18ec646?placeholderIfAbsent=true"
                alt="Partner logo 1"
                className="object-contain shrink-0 self-stretch my-auto aspect-[5.78] w-[196px]"
              />
              <img
                src="https://cdn.builder.io/api/v1/image/assets/1ac2c893557246f8ad2241f924b6a397/fa56c8658db22a9799ace3574ec001f42c20cb23?placeholderIfAbsent=true"
                alt="Partner logo 2"
                className="object-contain shrink-0 self-stretch my-auto aspect-[3.16] w-[155px]"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
